<template>
  <div :class="computedClass">
    <div class="logo" v-if="position === 'app'">
      <div class="logo__icon">
        <Logo />
      </div>
      <h1 class="title logo__title">Добро пожаловать на портал Промсервис</h1>
    </div>
    <div class="preloader">
      <svg class="circular-loader" width="100%" height="100%" viewBox="0 0 42 42">
        <circle cx="21" cy="21" r="18.2" fill="#E0E0E0" stroke="#E0E0E0" stroke-width="0.2"></circle>
        <circle cx="21" cy="21" r="13.6" fill="#ffffff" stroke="#E0E0E0" stroke-width="0.2"></circle>
        <circle cx="21" cy="21" r="15.91549430918954" fill="transparent"></circle>
        <circle class="loader-path" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="currentColor"
                stroke-width="4.5"></circle>
      </svg>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/page/Logo'

export default {
  name: 'the-page-preloader',
  components: { Logo },
  props: {
    // positions
    // page (для прелоадера на полную страницу), component (для расположения внутри компонента), app (на всё приложение)
    position: {
      type: String,
      default: 'page'
    }
  },
  methods: {},
  computed: {
    computedClass () {
      return {
        'preloader-page-mask': this.position === 'page',
        'preloader-component-mask': this.position === 'component',
        'preloader-app-mask': this.position === 'app'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.preloader-page-mask {
  top: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: $color-main;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 260px;

  @media screen and (max-width: $tablet_start) {
    padding-left: 0;
  }
}

.preloader-component-mask {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba( 255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}

.preloader-app-mask {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999;
  width: 100%;
  height: 100%;
  background: $color_main;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 14px 20px;

  &__icon {
    margin-bottom: 10px;
  }

  &__title {
    text-align: center;
  }
}

.preloader {
  position: relative;
  width: 60px;
  height: 60px;
  color: #7D0E7F;
}

.circular-loader {
  -webkit-animation: rotate 2s linear infinite;
  animation: rotate 2s linear infinite;
  height: 100%;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  transform-origin: center center;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  margin: auto;
}

.loader-path {
  stroke-dasharray: 150,200;
  stroke-dashoffset: -10;
  -webkit-animation: dash 1.2s ease-in-out infinite, color 6s ease-in-out infinite;
  animation: dash 1.2s ease-in-out infinite, color 6s ease-in-out infinite;
  stroke-linecap: round;
}

@-webkit-keyframes rotate {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes rotate {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-webkit-keyframes dash {
  0% {
    stroke-dasharray: 1,200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89,200;
    stroke-dashoffset: -20;
  }
  100% {
    stroke-dasharray: 89,200;
    stroke-dashoffset: -94;
  }
}
@keyframes dash {
  0% {
    stroke-dasharray: 1,200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89,200;
    stroke-dashoffset: -20;
  }
  100% {
    stroke-dasharray: 89,200;
    stroke-dashoffset: -94;
  }
}
@-webkit-keyframes color {
  0% {
    stroke: #7D0E7F;
  }
  40% {
    stroke: #CF1285;
  }
  66% {
    stroke: #7D0E7F;
  }
  80%, 90% {
    stroke: #CF1285;
  }
}
@keyframes color {
  0% {
    stroke: #7D0E7F;
  }
  40% {
    stroke: #CF1285;
  }
  66% {
    stroke: #7D0E7F;
  }
  80%, 90% {
    stroke: #CF1285;
  }
}
</style>
